const PARAM = 'open_from'

const isAbsoluteUrl = (to) => /^[a-z][a-z\d+\-.]*:/i.test(to)

const currentParamValue = () => new URLSearchParams(window.location.search).get(PARAM)

const decorateString = (to, value) => {
	if (isAbsoluteUrl(to) || to.includes(`${PARAM}=`)) return to
	const [pathAndQuery, hash] = to.split('#')
	const separator = pathAndQuery.includes('?') ? '&' : '?'
	const decorated = `${pathAndQuery}${separator}${PARAM}=${encodeURIComponent(value)}`
	return hash ? `${decorated}#${hash}` : decorated
}

const decorateDescriptor = (to, value) => {
	const params = new URLSearchParams(to.search ?? '')
	if (params.get(PARAM)) return to
	params.set(PARAM, value)
	return { ...to, search: `?${params.toString()}` }
}

/**
 * Keeps `?open_from=…` across in-app navigations.
 *
 * The professional area can embed a whole flow (add product → collection → configurator →
 * compositor) inside its docked side panel. The marker travels in the URL so the screen that
 * finally saves knows it is embedded and must report back to the panel instead of navigating.
 * Wrapping the single history instance covers every navigation path in the app —
 * `useCustomHistory`, react-router's `useHistory` and `<Link>` all push through it — so no
 * screen has to remember to forward the parameter.
 *
 * Only relative destinations are touched, and only while the parameter is present in the
 * current URL: outside the panel this is a no-op.
 */
export const withPreservedPanelParam = (history) => {
	const push = history.push.bind(history)
	const replace = history.replace.bind(history)

	const decorate = (to) => {
		const value = currentParamValue()
		if (!value || !to) return to
		if (typeof to === 'string') return decorateString(to, value)
		if (typeof to === 'object') return decorateDescriptor(to, value)
		return to
	}

	history.push = (to, state) => push(decorate(to), state)
	history.replace = (to, state) => replace(decorate(to), state)

	return history
}
